import { render, staticRenderFns } from "./DraftQuotation.vue?vue&type=template&id=1751a3f8&scoped=true&"
import script from "./DraftQuotation.vue?vue&type=script&lang=js&"
export * from "./DraftQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1751a3f8",
  null
  
)

export default component.exports